<template>
  <tr>
    <td width="70%">
      <p>{{ member.FirstName }} {{ member.LastName }}</p>
    </td>
    <td width="30%">
      <v-icon
        v-show="renewalStatus == 'success'"
        class="member-icon"
        color="#27ae60"
      >
        mdi-check-bold
      </v-icon>

      <v-icon
        v-show="renewalStatus == 'error'"
        class="member-icon"
        color="#ce3137"
      >
        mdi-alert-circle
      </v-icon>
    </td>
  </tr>
</template>

<script>
export default {
  name: "RenewMembershipHouseholdMember",

  props: ["member"],

  computed: {
    renewalStatus() {
      const renewalData =
        this.$store.state.membershipRenewal.renewalStatuses.find((m) => {
          return m.memberId == this.member.Id;
        });

      return renewalData ? renewalData.status : null;
    },
  },
};
</script>

<style scoped>
.member-loading,
.member-icon {
  height: 1rem !important;
  margin-bottom: 10px;
}

tr td {
  padding-right: 2rem;
  line-height: initial;
}

.dph-select {
  font-size: 0.85rem;
}
</style>
